import { addDays } from 'date-fns';

import { formatDate } from 'helpers/date';

import locales from './locales';

export const formatRelativeDate = (days: number, format: 'PP' | 'yyyy-MM-dd') =>
  formatDate(addDays(new Date(), days), format);

export const formatDeactivationDate = (date: string | undefined) =>
  !date || date === '' ? undefined : formatDate(new Date(date), 'yyyy-MM-dd');

export const getRelativeDateTitle = (days: number) => {
  if (days === 1) {
    return locales.deactivateAt.options.tomorrow;
  }

  if (days === 30) {
    return locales.formatString(locales.deactivateAt.options.inMonth, {
      months: 1,
    });
  }

  return locales.formatString(locales.deactivateAt.options.inDays, {
    days,
  });
};
